export default __webpack_public_path__ + "static/media/img-splice-2.bd505ff6.png";